import { v4 } from 'uuid';

export const CONTENT_TYPE = {
  videos: {
    label: 'Training Videos',
    value: 'video'
  },
};

export const TopicId = {
  FILING_CLAIMS: v4(),
  USER_MANAGEMENT: v4(),
  REMITTANCE: v4(),
  REMITTANCE_FAQs: v4(),
};

export const supportContentData = {
  faqList: [
    {
      id: v4(),
      question: 'How do I file a claim?',
      answer: 'From the browse claims view, click the FILE A NEW CLAIM button in the top right.'
    },
    {
      id: v4(),
      question: 'How do I view the details of a claim?',
      answer: 'From the browse claims view, click on any claim to view the details.'
    },
    {
      id: v4(),
      question: 'How do I upload a document to a claim?',
      answer: 'From the claims detail view, click on the documents tab, select the document category you want to upload documents to and drag your file into the document buckets.'
    }
  ],
  videoData: {
    topics: [
      {
        id: TopicId.FILING_CLAIMS,
        name: 'Filing Claims',
        videos: [
          {
            id: v4(),
            title: 'Appearance Protection',
            length: '2:55',
            thumbnailSrc: '/static/images/ECP thumbnail.PNG',
            videoSrc: 'https://nationsafedrivers-my.sharepoint.com/:v:/p/rfuller/EVVOeTz-2iZFgli-CLahQSABD1AmCD9S-VOLf2CHIQNScw?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJPbmVEcml2ZUZvckJ1c2luZXNzIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXciLCJyZWZlcnJhbFZpZXciOiJNeUZpbGVzTGlua0NvcHkifX0&e=AiVdNv'
          },
          {
            id: v4(),
            title: 'Tire And Wheel',
            length: '7:29',
            thumbnailSrc: '/static/images/tire wheel thumbnail.PNG',
            videoSrc: 'https://nationsafedrivers-my.sharepoint.com/:v:/p/rfuller/EcRlBJpNtppIpIy3qk0RAeIBl5Y1QHHJtlXpfmg9MvAjVw?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJPbmVEcml2ZUZvckJ1c2luZXNzIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXciLCJyZWZlcnJhbFZpZXciOiJNeUZpbGVzTGlua0NvcHkifX0&e=XKAucf'
          },
          {
            id: v4(),
            title: 'Key Replacement',
            length: '2:00',
            thumbnailSrc: '/static/images/key replace thumbnail.PNG',
            videoSrc: 'https://nationsafedrivers-my.sharepoint.com/:v:/p/rfuller/EWFkEH9r-0pEqx2-402_3fsBOzvEl7_GEiaK5uHulwaxEA?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJPbmVEcml2ZUZvckJ1c2luZXNzIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXciLCJyZWZlcnJhbFZpZXciOiJNeUZpbGVzTGlua0NvcHkifX0&e=Nq9OY2'
          },
          {
            id: v4(),
            title: 'Windshield',
            length: '3:54',
            thumbnailSrc: '/static/images/windshield thumbnail.PNG',
            videoSrc: 'https://nationsafedrivers-my.sharepoint.com/:v:/p/rfuller/EWMB6r6SOztNusYQWqiw64EBpvlMx-MbAb4yZBxJ3PObYw?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJPbmVEcml2ZUZvckJ1c2luZXNzIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXciLCJyZWZlcnJhbFZpZXciOiJNeUZpbGVzTGlua0NvcHkifX0&e=9ebSeP'
          },
          {
            id: v4(),
            title: 'Paintless Dent Repair',
            length: '3:17',
            thumbnailSrc: '/static/images/dent thumbnail.PNG',
            videoSrc: 'https://nationsafedrivers-my.sharepoint.com/:v:/p/rfuller/EVRVz-FSkKBDnB2_w3BHJHkBkLB6-BwH8bmSXXJTI2JqAg?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJPbmVEcml2ZUZvckJ1c2luZXNzIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXciLCJyZWZlcnJhbFZpZXciOiJNeUZpbGVzTGlua0NvcHkifX0&e=qJzHse'
          },
        ]
      },
      {
        id: TopicId.USER_MANAGEMENT,
        name: 'User Management',
        videos: [
          {
            id: v4(),
            title: 'Managing Users',
            length: '8:00',
            thumbnailSrc: '/static/images/user mgmt thumbnail.PNG',
            videoSrc: 'https://nationsafedrivers-my.sharepoint.com/:v:/p/rfuller/EZXGeA-pA5RKiCdN6k8ikpwBtTLjzxLDn6dT-OZccLaFBQ?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJPbmVEcml2ZUZvckJ1c2luZXNzIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXciLCJyZWZlcnJhbFZpZXciOiJNeUZpbGVzTGlua0NvcHkifX0&e=o0rtXD'
          },
        ]
      },
      {
        id: TopicId.REMITTANCE,
        name: 'Remittance',
        videos: [
          {
            id: v4(),
            title: 'Remittance',
            length: '3.55',
            thumbnailSrc: '/static/images/thumbnail_HowToSubmitContractRemittance.PNG',
            videoSrc: 'https://nationsafedrivers-my.sharepoint.com/:v:/p/rfuller/Eb6NJZRlSklJk_FwC0iTiUcBI_gup3_wa04JCYfdp9phIw?nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJPbmVEcml2ZUZvckJ1c2luZXNzIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXciLCJyZWZlcnJhbFZpZXciOiJNeUZpbGVzTGlua0NvcHkifX0&e=9AQ09e'
          },
        ]
      },
      {
        id: TopicId.REMITTANCE_FAQs,
        name: 'Remittance FAQs',
        videos: [
          {
            id: v4(),
            title: 'How to Submit Remittance',
            ifPdf: true,
            thumbnailSrc: '/static/images/thumbnail_SubmitRemittance_FAQs.PNG',
            pdfSrc: 'https://nationsafedrivers-my.sharepoint.com/:b:/p/rfuller/ERdwxpIBgCpNoFKy11L_vRoBEG9iS6pslfgIVPM_CijFDA?e=2d1b4c',
            videoSrc: 'https://nationsafedrivers-my.sharepoint.com/:b:/p/rfuller/ERdwxpIBgCpNoFKy11L_vRoBEG9iS6pslfgIVPM_CijFDA?e=2d1b4c'
          },
          {
            id: v4(),
            title: 'Wire Payment Instructions',
            ifPdf: true,
            thumbnailSrc: '/static/images/thumbnail_WirePaymentInstructions_FAQs.PNG',
            pdfSrc: 'https://nationsafedrivers-my.sharepoint.com/:b:/p/rfuller/EeSwJMeZ-11Opa6XDzLv4DkBICVlF15codJlLSG_fauN5A?e=8zIye7',
            videoSrc: 'https://nationsafedrivers-my.sharepoint.com/:b:/p/rfuller/EeSwJMeZ-11Opa6XDzLv4DkBICVlF15codJlLSG_fauN5A?e=8zIye7'
          },
        ]
      },
    ],
  }
};